import { Component, Input, OnInit } from '@angular/core';
import { PreferenceControlModule } from '@models/preference-control-modules.model';
import { PreferenceControlModuleManager } from '@services/preference-control-module-manager';
import { ControlModuleId } from '@models/control-module-id.enum';
import { BaseComponent } from '../../base.component';
import { UserConfigsService } from '@services/user-configs.service';
import { switchMap, take } from 'rxjs/operators';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'lex-expandable-container',
    templateUrl: './expandable-container.component.html',
    styleUrls: ['./expandable-container.component.scss'],
    standalone: false
})
export class ExpandableContainerComponent extends BaseComponent implements OnInit {
	@Input() disabled: boolean = false;
	@Input() panelTitle: string = '';
	@Input() controlModuleId: ControlModuleId | string;

	private _controlModule: PreferenceControlModule;

	constructor(
		private preferenceControlModuleManager: PreferenceControlModuleManager,
		private userConfigService: UserConfigsService
	) {
		super();
	}

	public ngOnInit(): void {
		this.preferenceControlModuleManager.getPreferenceControlModule$(this.controlModuleId).pipe(
			takeUntil(this.destroy$)
		).subscribe((controlModule) => {
			if (!controlModule) {
				this.updatePreference(true);
			}

			if (controlModule?.moduleId) {
				this._controlModule = controlModule;
			}
		});
	}

	public setIsCollapsed(isCollapsed: boolean): void {
		if (isCollapsed === this._controlModule.isCollapsed) {
			return;
		}
		this.updatePreference(isCollapsed);
	}

	public isExpanded(): boolean {
		if (this._controlModule?.isCollapsed === undefined)
			return false;

		return !this._controlModule?.isCollapsed;
	}

	private updatePreference(isCollapsed: boolean) {
		this.userConfigService.getUserConfigs().pipe(
			take(1),
			switchMap((configs) => {
				if (!configs)
					return;

				const controlModule: PreferenceControlModule = {
					userId: configs.userId,
					caseId: configs.currentCase.caseId,
					moduleId: this.controlModuleId,
					isCollapsed: isCollapsed
				};
				return this.preferenceControlModuleManager.updateControlModuleState(controlModule);
			})
		).subscribe();
	}
}
